import React from 'react';
import { Button } from '@mui/material';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { currentAudioSingleton } from 'utils/assetLoader';
import { t } from '../translations';

const PlayPauseButton = ({ isPlaying, onClick }) => (
  <Button
    aria-label={isPlaying ? t('Pause') : t('Play')}
    onClick={onClick}
    disabled={!currentAudioSingleton.get()}
    sx={{
      color: 'black',
      fontSize: '20px',
      background: 'none',
      cursor: 'pointer',
      border: '2px solid black',
      borderRadius: '10px',
      maxHeight: '38px',
      maxWidth: '55px',
      '&:disabled': {
        color: 'lightgrey',
        borderColor: 'lightgrey',
        cursor: 'not-allowed'
      },
      '@media (max-width: 400px)': {
        fontSize: '10px',
        minWidth: '20px'
      }
    }}
    type="button"
  >
    <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
  </Button>
);

PlayPauseButton.propTypes = {
  isPlaying: require('prop-types').bool.isRequired,
  onClick: require('prop-types').func.isRequired
};

export default PlayPauseButton;
